// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
import { getAnalytics } from "firebase/analytics";
import { getAuth, GoogleAuthProvider } from "firebase/auth";

// Your web app's Firebase configuration
// For Firebase JS SDK v7.20.0 and later, measurementId is optional
const firebaseConfig = {
  apiKey: "AIzaSyBFxDMybuEaaU0cVpudXhuzsDx2LhWK7lA",
  authDomain: "datasci-playground-dev-3180.firebaseapp.com",
  projectId: "datasci-playground-dev-3180",
  storageBucket: "datasci-playground-dev-3180.firebasestorage.app",
  messagingSenderId: "933099180301",
  appId: "1:933099180301:web:e95e88d02d8a6a67272044",
  measurementId: "G-K5DFRJFYLZ"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);
const analytics = getAnalytics(app);
const auth = getAuth(app);
const googleProvider = new GoogleAuthProvider();

export { app, analytics, auth, googleProvider };

